/* 🤖 this file was generated by svg-to-ts */
export const matIconWbTwilight: {
  name: 'wb-twilight';
  data: string;
} = {
  name: 'wb-twilight',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m16.955 8.662 2.12-2.122 1.416 1.414-2.121 2.122zM2 18h20v2H2zm9-14h2v3h-2zM3.543 7.925 4.957 6.51l2.121 2.12-1.414 1.415zM5 16h14c0-3.87-3.13-7-7-7s-7 3.13-7 7z"/></svg>`
};
